import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService, User} from '@hassel-it/angular-common';

declare let NProgress: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'my-app',
    templateUrl: 'login.component.html',
    providers: [AuthService]
})

export class LoginComponent implements OnInit {

        public user = new User();
    public uuid: string;
    public key: string;
    public reset = false;
    public submitted = false;
    public alertType = 'warning';
    public alert = '';

    public returnUrl: string = null;

    constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute,
    ) {
    }

    async ngOnInit() {

        this.route.queryParamMap.subscribe(parmas => {
            this.uuid = parmas.get('uuid');
            this.key = parmas.get('key');
            this.returnUrl = parmas.get('returnUrl');

            NProgress.start();
            this.submitted = true;
            // workaround hvis vi er logget ind server side, så kald login api og log os ind client side
            this.authService.authenticateUser().then(success => {

                if (this.returnUrl) {
                    this.router.navigateByUrl(this.returnUrl);
                } else {
                    this.router.navigateByUrl('/');
                }
                NProgress.done();
            }, error => {
                this.submitted = false;
                NProgress.done();
            });
        });
    }

    onSubmit() {
        this.alert = '';
        this.submitted = true;

        if (this.reset) {

            this.alert = '';
            this.submitted = true;
            this.authService.startReset(this.user.username).then((result: any) => {
                this.submitted = false;
                this.alert = ('We have sent an email with instructions'); // @todo better reponses
                this.alertType = 'success';
                this.clearForm();
            }, (error: any) => {
                this.alert = ('Could not start reset'); // @todo better reponses
                this.submitted = false;
            });
        } else {

            this.authService.authenticateUser(this.user.username, this.user.password)
                .then(() => {
                    if (this.returnUrl) {
                        this.router.navigateByUrl(this.returnUrl);
                    } else {
                        this.router.navigateByUrl('/');
                    }
                }, (error: any) => {
                    this.alert = 'Error logging in';
                    this.submitted = false;
                });

        }
    }

    finishResetPassword() {
        this.alert = '';
        this.submitted = true;
        this.authService.finishReset({
            password: this.user.password,
            password_confirm: this.user.password_confirm,
            uuid: this.uuid,
            temp_password: this.key
        }).then((response: any) => {
            this.alert = 'Password changed, logging in'; // @todo better reponses
            this.alertType = 'success';
            return this.authService.login(response);
        }, (error: any) => {
            return Promise.reject('Error resetting password'); // HERE
        }).then(result => {
            this.alert = 'Done'; // @todo better reponses
            this.router.navigateByUrl('/');
        }).catch(result => {
            this.alert = 'Error resetting password';
            this.submitted = false;
        });
    }

    clearForm() {
        this.reset = false;
        this.user = new User();
        this.submitted = false;
    }
}
